"use client";

import { useTranslations } from "@/i18n/client";

export const Translate = ({ value }: { value: string }) => {
	const t = useTranslations();
	return <>{t(value)}</>;
};
